module.exports = __webpack_public_path__ + "spsa logo.39af291.png";